package com.neurobs.react

import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.web.html.{className, div, i, onClick}

@react object RefreshButton {
	case class Props
	(
		onClick: () => Unit
	)
	val component = FunctionalComponent[Props] { props =>
		//div(className := "nfw-refresh-button", onClick := props.onClick)(
			i(className := "fa-solid fa-rotate nfw-refresh-button", onClick := props.onClick)
		//)
	}
}